import { useSelector } from "react-redux";
import FloatingSupportList from "./FloatingSupportList";
import FloatingSupportWhatsapp from "./FloatingSupportWhatsapp";

/**
 * A component that renders the floating support button on the bottom of the screen.
 *
 * @returns {JSX.Element}
 */

const FloatingSupportButton = () => {
  const user = useSelector((state) => state.authData.user);
  const data = useSelector((state) => state.cachedRequests.chatLink);

  return user?.hasOwnProperty("agent") ? (
    <FloatingSupportList data={data} />
  ) : (
    <FloatingSupportWhatsapp data={data} />
  );
};

export default FloatingSupportButton;
